import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { orgLogin, saveOrgSession } from "../services/api";

export default function OwnerLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const d = await orgLogin(email.trim(), password);
      saveOrgSession(d.access_token, d.organization);
      nav("/owner", { replace: true });
    } catch (e2) {
      setErr("Invalid email or password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={wrap}>
      <form onSubmit={submit} style={card}>
        <h2 style={{ marginTop: 0 }}>Owner sign-in</h2>
        <p style={{ color: "#667", marginTop: 0, fontSize: 14 }}>
          Group owners only. Branch managers and staff sign in at the normal login.
        </p>
        {err && <div style={{ color: "#b00", marginBottom: 8 }}>{err}</div>}
        <input type="email" placeholder="Owner email" value={email} autoFocus
               onChange={(e) => setEmail(e.target.value)} style={inp} />
        <input type="password" placeholder="Password" value={password}
               onChange={(e) => setPassword(e.target.value)} style={inp} />
        <button className="btn" disabled={busy || !email || !password}
                style={{ width: "100%", marginTop: 10 }}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}

const wrap = { display: "flex", justifyContent: "center", alignItems: "flex-start", padding: "48px 16px" };
const card = { background: "#fff", borderRadius: 12, padding: 24, width: 360, maxWidth: "100%", boxShadow: "0 8px 30px rgba(0,0,0,.12)" };
const inp = { display: "block", width: "100%", boxSizing: "border-box", margin: "8px 0", padding: "10px", border: "1px solid #cdd8e3", borderRadius: 8 };
